import { IxLabelTag } from './IxLabelTag.js';

window.customElements.define('ix-label-tag', IxLabelTag);
